export default `
clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);
`
